import { jsonProperty, Serializable } from "ts-serializable";
import Resposta from "./Resposta";

class Avaliacao extends Serializable{

    @jsonProperty(String, null)
    questionarioId: string | null = null;

    @jsonProperty(Number, null)
    versao: number | null = null;

    @jsonProperty(Boolean, null)
    finalizada: boolean | null = false;

    @jsonProperty([Resposta], null)
    respostas: Resposta | null = null;

}  

export default Avaliacao;